import axios from 'axios'

//const textUrl = 'http://192.168.100.168:8003' // 开发1
 const textUrl = 'https://api.720joy.com' //正式

var requests = axios.create({
	baseURL: textUrl,
	timeout: 30000,
})
// request拦截器
requests.interceptors.request.use(config => {
	let token = localStorage.getItem("token")
	if (token) {
		config.headers["t-token"] = token
	}
	return config
})
// response拦截器
// requests.interceptors.response.use(config => {
//   console.log(config)
// })

export default requests